// src/App.js
import React from "react";
import AppRouter from "./AppRouter";
import { MultiLang } from "react-multi-lang";
import "bootstrap-icons/font/bootstrap-icons.css";
// this is for the chatbot
import { useRef } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";


function App() {
  const tawkMessengerRef = useRef();

  const handleMinimize = () => {
    tawkMessengerRef.current.minimize();
  };

  return (
    <div className="App">
      {/* <TawkMessengerReact
        propertyId="6788c32b3a842732606ff796"
        widgetId="1ihn3kpba"
        useRef={tawkMessengerRef}
      /> */}
      <AppRouter />
    </div>
  );
}

export default App;
